export enum StateEnum {
  Unchanged,
  Inserted,
  Updated,
  Deleted,
};